<!-- Mobile floating menu button -->
<div class="sidebar__floating-menu-button hidden-lg-up" (click)="toggleSideMenu()">
  <span nz-icon [nzType]="isSideMenuDrawerVisible ? 'close' : 'menu'" nzTheme="outline"></span>
</div>

<!-- Sidebar drawer for mobile -->
<nz-drawer
  [nzVisible]="isSideMenuDrawerVisible"
  nzPlacement="right"
  [nzClosable]="false"
  (nzOnClose)="closeSideMenu()"
  [nzWidth]="300"
  [nzBodyStyle]="{ padding: '0' }"
  [nzWrapClassName]="'side-menu-drawer'"
>
  <div *nzDrawerContent class="drawer-sidebar-container">
    <div class="sidebar__container">
      <div class="sidebar__header">
        <img src="/assets/icons/key_7_logo.svg" alt="" />

        <button nz-button nzType="primary" ngClass="zeta" class="sidebar__gamepad-button">
          <span nz-icon nzType="ng-zorro:gamepad" nzTheme="outline"></span>
          <div class="notification-badge">4</div>
        </button>
      </div>

      <!-- Copy of the main sidebar content for drawer -->
      <ng-container *ngTemplateOutlet="sidebarContent"></ng-container>

      <!-- Mobile-only apply button -->
      <div class="sidebar__apply-button-container">
        <button nz-button nzType="primary" class="alpha sidebar__apply-button" (click)="closeSideMenu()">
          Apply Filters
        </button>
      </div>
    </div>
  </div>
</nz-drawer>

<div class="sidebar__container fixed hidden-lg-down">
  <div class="sidebar__header">
    <img src="/assets/icons/key_7_logo.svg" alt="" />

    <button nz-button nzType="primary" ngClass="zeta" class="sidebar__gamepad-button">
      <span nz-icon nzType="ng-zorro:gamepad" nzTheme="outline"></span>
      <div class="notification-badge">4</div>
    </button>
  </div>

  <!-- Shared sidebar content -->
  <ng-container *ngTemplateOutlet="sidebarContent"></ng-container>
</div>

<!-- Template for shared sidebar content -->
<ng-template #sidebarContent>
  <div class="sidebar__sub-header">
    <h2 class="sidebar__title">Keys Found</h2>
    <p class="sidebar__count">{{ totalMatches }} Matches</p>
  </div>

  <div class="sidebar__search">
    <input nz-input nzType="primary" placeholder="Search..." class="sidebar__search-input">
    <button nz-button nzType="primary" class="sidebar__search-button alpha">
      <span nz-icon nzType="search" nzTheme="outline"></span>
    </button>
  </div>

  <div class="sidebar__applied-filters" *ngIf="appliedFilters.length > 0">
    <h3 class="sidebar__filters-title">Filters Applied</h3>
    <div class="sidebar__filters-tags">
      <nz-tag
        *ngFor="let filter of visibleFilters"
        nzMode="closeable"
        ngClass="gamma"
        (nzOnClose)="removeFilter(filter)">
        {{ filter.facetName }}
      </nz-tag>
      <nz-tag
        *ngIf="hasHideIgnoredFilter()"
        nzMode="closeable"
        ngClass="gamma"
        (nzOnClose)="removeHideIgnoredFilter()">
        Hide Ignored Items
      </nz-tag>
      <nz-tag
        *ngIf="hiddenFiltersCount > 0"
        ngClass="gamma more-filters-tag">
        +{{ hiddenFiltersCount }} more
      </nz-tag>
    </div>
    <button nz-button nzType="primary" class="beta sidebar__reset-button" (click)="resetFilters()">Reset</button>
  </div>

  <div class="sidebar__filter-container">
    <!-- Dynamic Filter Sections -->
    <div *ngFor="let section of filterSections" class="sidebar__filter-section">
      <div class="sidebar__filter-header" (click)="openFilterModal(section.id, filterModalContent)">
        <div class="sidebar__filter-title-container">
          <span nz-icon [nzType]="section.icon" nzTheme="outline" class="sidebar__filter-icon"></span>
          <h3 class="sidebar__filter-title">{{ section.name }}</h3>
        </div>
        <div class="sidebar__filter-badge-container">
          <span class="sidebar__filter-badge" *ngIf="hasSelectedOptions(section)">
            {{ getSelectedCount(section) }}
          </span>
          <span class="sidebar__filter-toggle" nz-icon nzType="right" nzTheme="outline"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Price Range Section -->
  <div class="sidebar__price-section">
    <h3 class="sidebar__price-title">Price</h3>
    <div class="sidebar__price-range">
      <div class="sidebar__price-input">
        <span>€ {{ priceRange[0] }}</span>
      </div>
      <span class="sidebar__price-separator">-</span>
      <div class="sidebar__price-input">
        <span>€ {{ priceRange[1] }}</span>
      </div>
    </div>
    <nz-slider
      class="sidebar__price-slider"
      [nzRange]="true"
      [nzMin]="0"
      [nzMax]="200"
      [(ngModel)]="priceRange"
      [nzTooltipVisible]="'never'">
    </nz-slider>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #filterModalContent>
  <div class="filter-modal__container">
    <div *ngIf="currentModalFilter" class="filter-modal__options-grid">
      <ng-container *ngIf="getFilterSection(currentModalFilter) as filterSection">
        <div
          *ngFor="let option of filterSection.options"
          class="filter-modal__grid-item"
          [class.filter-modal__grid-item--selected]="option.selected"
          (click)="toggleOptionSelection(option)">
          <div class="filter-modal__item-content">
            <div class="filter-modal__item-icon">
              <span nz-icon [nzType]="option.icon" nzTheme="outline"></span>
              <div class="filter-modal__selected-indicator" *ngIf="option.selected">
                <span nz-icon nzType="check" nzTheme="outline"></span>
              </div>
            </div>
            <div class="filter-modal__item-name">{{ option.name }}</div>
            <div class="filter-modal__item-count">{{ option.count }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
